import React, { useState, useEffect } from 'react';
import style from './CustomHealthSlideDetail.module.css';
import styled from 'styled-components';
import BackIcon from '../../../../images/common/i_back_arrow_btn.svg';
import { Navigation, Pagination } from 'swiper/modules';
import LocationImageView from '../../../../components/box/LocationImageView';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModalContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: white;
    overflow: hidden;
    animation: slideUp 0.3s ease-in-out;

    @keyframes slideUp {
        from {
            transform: translateY(50px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    gap: var(--sp-06);
    height: var(--sp-50);
    padding: var(--sp-16);
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
`;

const ModalTitle = styled.h2`
    font-size: var(--mo-fz-md);
    font-weight: var(--fz-weight-700);
    color: var(--color-main-black);
`;

const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 24px;
    color: var(--color-main-gray);
    
    &:hover {
        opacity: 0.7;
    }
`;

const ModalContent = styled.div`
    padding: 0 var(--sp-16);
    overflow-y: auto;
    height: calc(100vh - 50px);
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

const CustomHealthSlideDetail = ({ isOpen, onClose, title, content }) => {
    const [slideNaviHide, setSlideNaviHide] = useState(false);
    const [showFullImage, setShowFullImage] = useState(false);
    const [saveImgUrl, setSaveImgUrl] = useState('');
    const [srcList, setSrcList] = useState([]);

    useEffect(() => {
        if (content) {
            const imgArr = content.split(',').map((url) => url.trim());
            setSrcList(imgArr);
        }
    }, [content]);


    // 모달 열릴 때 html에 data-scroll='no' 추가 및 브라우저 뒤로가기 처리
    useEffect(() => {
        if (isOpen) {
            document.documentElement.setAttribute('data-scroll', 'no');
            
            // 히스토리에 상태 추가
            window.history.pushState({ modal: 'slide' }, '');
            
            // 뒤로가기 이벤트 처리
            const handlePopState = (e) => {
                if (e.state?.modal === 'slide' || !e.state) {
                    return; // 모달 히스토리로 돌아온 경우 무시
                }
                onClose();
            };
            
            window.addEventListener('popstate', handlePopState);
            
            return () => {
                document.documentElement.removeAttribute('data-scroll');
                window.removeEventListener('popstate', handlePopState);

                // 모달이 닫힐 때 추가된 히스토리 제거
                if (window.history.state?.modal === 'slide') {
                    window.history.back();
                }
            };
        } else {
            document.documentElement.removeAttribute('data-scroll');
        }
    }, [isOpen, onClose]);


    const handleViewFullImage = (imgUrl) => {
        setSaveImgUrl(imgUrl);
        setShowFullImage(true);
    };

    const handleCloseFullImage = () => {
        setShowFullImage(false);
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <ModalOverlay onClick={handleOverlayClick}>
                <ModalContainer>
                    <ModalHeader>
                        <CloseButton onClick={onClose}>
                            <img src={BackIcon} alt="뒤로가기" />
                        </CloseButton>
                        <ModalTitle>상세 보기</ModalTitle>
                    </ModalHeader>
                    <ModalContent>
                        <strong className={style['title']}>{title}</strong>
                        
                        <div className={style['position-box']}>
                            <div className={style['swiper-wrap-box']}>
                                <Swiper
                                    pagination={{
                                        el: '.side-fractions',
                                        type: 'custom',
                                        renderCustom: function (swiper, current, total) {
                                            return (
                                                ((current < 10) ? ('0' + current) : current)
                                                + ' / ' +
                                                (((total) < 10) ? ('0' + (total)) : (total))
                                            );
                                        }
                                    }}
                                    modules={[Navigation, Pagination]}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                >
                                    {
                                        srcList.length > 0 && srcList.map((item, index) => (
                                            <SwiperSlide key={index}>
                                                <div className="img-box">
                                                    <img
                                                        src={item}
                                                        alt=""
                                                        onClick={() => handleViewFullImage(item)}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>

                                {!slideNaviHide && (
                                    <div className={style['navi-box']}>
                                        <div className='swiper-button-prev'>
                                            <button className={`${style.slideBtn} ${style.prevBtn}`}></button>
                                        </div>
                                        <p className='side-fractions'></p>
                                        <div className='swiper-button-next'>
                                            <button className={`${style.slideBtn} ${style.nextBtn}`}></button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </ModalContent>
                </ModalContainer>
            </ModalOverlay>

            {showFullImage && (
                <LocationImageView
                    imgUrl={saveImgUrl}
                    visible={showFullImage}
                    onClose={handleCloseFullImage}
                />
            )}
        </>
    );
};

export default CustomHealthSlideDetail;